module.exports = __webpack_public_path__ + "img/elevator.ea09ba83.jpg";